import { Button, Container, Dialog, Divider, Grid, Paper, Tooltip, Typography } from '@material-ui/core'
import React, { useContext, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { ACTIONS, PolicyModificationContextStore } from '../../../context/PolicyModificationContext'
import { Action } from '../../../models/Action'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import { ContinueButton } from '../../Core/Buttons/ContinueButton'
import { PolicyManagementContextStore } from '../../../context/PolicyManagementContext'
import { coveragesToIgnore, MotorcyclesCoveragesMapping, PolicyCoveragesMapping } from '../../../models/insurance-models/CoveragesMapping'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { ReactComponent as ShieldSvg } from '../../../assets/shield_with_v.svg'
import { awaitWithLoading, CentPretty, currencySymbol } from '../../../services/utils'
import './ModificationSummary.scss'
import policyModificationApi from '../../../api/policyModification.api'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'
import { useHistory } from 'react-router-dom'
import { BillingPlanSpecialSelect } from '../../Insurance/Plans/Sections/BillingPlanSectionSelect'
import { SkywatchDialog } from '../../PopUps/SkywatchDialog'
import { GreenButton } from '../../Core/Buttons/GreenButton'
import coveragesApi from '../../../api/coverages.api'

export const ModificationSummary = ({ onBack, tabIndex }) => {
  const modifyContext = useContext(PolicyModificationContextStore)
  const offersContext = useContext(BuyingInsuranceContextStore)
  const policyManagementContext = useContext(PolicyManagementContextStore)
  const history = useHistory()
  const [clickedSave, setClickedSave] = useState(false)
  const [openMidtermAmount, setOpenMidtermAmount] = React.useState(false)
  const [midtermAmountDetails, setmidtermAmountDetails] = React.useState({ result: [] })
  const motorcyclesDetails = modifyContext.isRenewal ? modifyContext.offer.motorocycles_offer : modifyContext.motorcycles_odometer_details
  const onBackClick = () => {
    modifyContext.dispatch(new Action(ACTIONS.BACK_TO_MODIFICATION))
  }

  const handleClose = () => {
    setClickedSave(false)
  }

  const onSave = async () => {
    const res = await awaitWithLoading(
      policyModificationApi.SavePolicyChanges({
        insurance_id: modifyContext.insuranceId,
        policy_owner_details: modifyContext.owner_details,
        insured_vehicles: modifyContext.motorcycles_details,
        insured_persons: modifyContext.rider_details,
        policy_coverages: modifyContext.policy_coverages,
        signed_coverages_details: modifyContext.coveragesToSign.coverageSigningInfo,
        is_renewal: modifyContext.isRenewal,
        billing_period: modifyContext.billingPeriod,
      })
    )

    if (res.ok) {
      await policyManagementContext.loadPolicies()
      setOpenMidtermAmount(false)
      history.replace('/policy-management')
      modifyContext.dispatch(new Action(ACTIONS.RESET))
      setClickedSave(false)
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  const getPolicyCoverageValue = (coverage_options, covId, coverage) => {
    let covName = ''
    coverage_options.forEach(cov => {
      if (cov.value == covId) {
        if (cov.name == 'No Coverage' || cov.name == '0') {
          covName = 'Not included'
        } else {
          if (coverage == 'medical_payments' || coverage == 'personal_injury_protection') {
            covName = cov.label
          } else {
            covName = cov.name
          }
        }
      }
    })
    return covName
  }

  const getMotorcycleCoverageValue = (coverage_options, covId) => {
    let covName = ''
    coverage_options.forEach(cov => {
      if (cov.value == covId) {
        covName = cov.label.replace('Deductible', '')
      }
    })
    return covName
  }

  const GetPeriodicPaymentTitle = () => {
    let periodicPaymentTitle = 'Monthly'
    switch (modifyContext.offer.billing_period) {
      case 'ThreeMonths':
        periodicPaymentTitle = '3 months'
        break
      case 'SixMonths':
        periodicPaymentTitle = '6 months'
        break
      case 'Annual':
        periodicPaymentTitle = 'Annual'
        break
    }

    return periodicPaymentTitle
  }

  const DownloadPdfRequest = async () => {
    const res = await awaitWithLoading(
      policyModificationApi.getFormsPDF({
        offer_id: modifyContext.offer.modify_offer_id,
        forms_required_signing: modifyContext.coveragesToSign.coverageSigningInfo,
        insurance_id: modifyContext.insuranceId,
        policy_owner: modifyContext.owner_details,
      })
    )
    if (res.ok) {
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(res.data)
      link.download = 'required_forms_to_sign.pdf'
      link.click()
      link.remove()
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  const getMidtermAmount = async () => {
    await awaitWithLoading(
      policyModificationApi.setSigningContext(
        {
          insurance_id: modifyContext.insuranceId,
          policy_owner_details: modifyContext.owner_details,
          insured_vehicles: modifyContext.motorcycles_details,
          insured_persons: modifyContext.rider_details,
          policy_coverages: modifyContext.policy_coverages,
          billing_period: modifyContext.billingPeriod,
          is_renewal: modifyContext.isRenewal,
        },
        modifyContext.insuranceId
      )
    )
    if (modifyContext.isUserNeedToSign) {
      await awaitWithLoading(coveragesApi.sendDigitalSignatureSigningFormByInsurance(modifyContext.insuranceId))
    }

    const midtermResponse = await awaitWithLoading(
      policyModificationApi.getMidtermAmount(
        {
          insurance_id: modifyContext.insuranceId,
          policy_owner_details: modifyContext.owner_details,
          insured_vehicles: modifyContext.motorcycles_details,
          insured_persons: modifyContext.rider_details,
          policy_coverages: modifyContext.policy_coverages,
          billing_period: modifyContext.billingPeriod,
          is_renewal: modifyContext.isRenewal,
        },
        modifyContext.insuranceId
      )
    )
    if (midtermResponse.ok) {
      setmidtermAmountDetails(midtermResponse.data)
      setOpenMidtermAmount(true)
    }
  }

  const onContinue = () => {
    if (modifyContext.isRenewal) {
      setClickedSave(true)
    } else {
      getMidtermAmount()
    }
  }

  return (
    <>
      <FlexView vAlignContent="center" hAlignContent="left">
        <div className="text-title margin-bottom-medium">{modifyContext.isRenewal ? 'Renewal' : 'Policy'} Modifications Summary</div>
      </FlexView>
      <Grid container spacing={4}>
        <Grid xs={12} md={4}>
          <Container className="margin-top-basic">
            <div className="black text-body margin-bottom-small bold">Operator(s) Detailes</div>

            {modifyContext.rider_details.map((operator, key) => {
              return (
                <FlexView className="space-between margin-top-small" key={key}>
                  <div className="black text-tiny">{operator.is_owner ? <div>Owner:</div> : <div>Rider:</div>}</div>
                  <div className="black text-tiny">
                    {operator.first_name} {operator.last_name}
                  </div>
                </FlexView>
              )
            })}

            <Divider />
            <div className="black text-body margin-bottom-small bold">Policy Coverages</div>
            {Object.entries(modifyContext.policy_coverages).map(([covName, covId]) => {
              let needToIgnore = false
              if (covName in coveragesToIgnore) {
                needToIgnore = coveragesToIgnore[covName].ignoreInCustomize
              }
              if (!needToIgnore) {
                return (
                  <FlexView key={covId} className="space-between margin-bottom-small">
                    <div className="black text-tiny"> {PolicyCoveragesMapping[covName].shortTitle}</div>
                    <div className="black text-tiny">{getPolicyCoverageValue(offersContext.options[covName], covId, covName)}</div>
                  </FlexView>
                )
              }
            })}
            <Divider />
          </Container>
        </Grid>
        <Grid xs={12} md={4}>
          <Container className="margin-top-basic">
            <div className="black text-body margin-bottom-small bold">Insured Motorcycle(s) Detailes</div>
            {modifyContext.motorcycles_details.map((vehicle, index) => (
              <div>
                <FlexView key={`${vehicle.id}${index}`} className="space-between margin-bottom-small">
                  <div className="black text-tiny">Model: </div>
                  <Tooltip
                    title={
                      <div className="white text-secondary">
                        {vehicle.make} {vehicle.model} {vehicle.year}
                      </div>
                    }
                  >
                    <div className="black text-tiny text-overflow-elipsis-small">
                      {vehicle.make} {vehicle.model} {vehicle.year}
                    </div>
                  </Tooltip>
                </FlexView>
              </div>
            ))}

            <Divider />
            <div className="black text-body margin-bottom-small bold">Motorcycle(s) Coverages</div>
            {modifyContext.motorcycles_details.map((vehicle, index) => {
              return (
                <div className="margin-bottom-small">
                  <FlexView key={index} className="space-between margin-top-small">
                    <Tooltip
                      title={
                        <div className="white text-secondary">
                          {vehicle.make} {vehicle.model} {vehicle.year}
                        </div>
                      }
                    >
                      <div className="black text-tiny text-overflow-elipsis-small margin-bottom-small bold">
                        {vehicle.make} {vehicle.model} {vehicle.year}
                      </div>
                    </Tooltip>
                  </FlexView>
                  {Object.entries(vehicle.vehicle_coverages).map(([covName, covId]) => {
                    let needToIgnore = false
                    if (covName in coveragesToIgnore) {
                      needToIgnore = coveragesToIgnore[covName].ignoreInCustomize
                    }
                    if (!needToIgnore) {
                      return (
                        <FlexView key={covId} className="space-between margin-bottom-small">
                          <div className="black text-tiny"> {MotorcyclesCoveragesMapping[covName].title}</div>
                          <div className="black text-tiny">{getMotorcycleCoverageValue(offersContext.options[covName], covId)}</div>
                        </FlexView>
                      )
                    }
                  })}
                  <FlexView className="space-between margin-bottom-small">
                    <div className="black text-tiny">Diminishing Deductible</div>
                    <div className="black text-tiny">{vehicle.is_diminishing_deductible ? 'Included' : 'Not Included'}</div>
                  </FlexView>
                  {/* <br/> */}
                </div>
              )
            })}
            <Divider />
          </Container>
        </Grid>
        <Grid xs={12} md={3}>
          {modifyContext.isRenewal && modifyContext.billingPeriodEnabled && (
            <div className="margin-bottom-basic">
              <div className="text-small bold margin-bottom-small">Payment Recurrence</div>
              <BillingPlanSpecialSelect
                value={modifyContext.billingPeriod}
                onChange={(name, value) => modifyContext.setBillingPeriod(value)}
              />
            </div>
          )}
          <FlexView className="policy-summary-container" column>
            <Paper elevation={3} className="policy-summary">
              <div className="policy-summary-headline">
                <FlexView className="space-between">
                  <FlexView vAlignContent={'center'}>
                    <ShieldSvg className="white-svg-path" />
                    <div className="white text-body bold margin-left-6">Recurrence Charge ({GetPeriodicPaymentTitle()})</div>
                  </FlexView>
                </FlexView>
              </div>
              {motorcyclesDetails.map((vehicle, index) => (
                <Container className="margin-top-basic" key={index}>
                  <Tooltip
                    title={
                      <div className="white text-secondary margin-bottom-small">
                        {vehicle.make} {vehicle.model} {vehicle.year}
                      </div>
                    }
                  >
                    <div className="blue text-tiny text-overflow-elipsis-small margin-bottom-small bold">
                      {vehicle.make} {vehicle.model} {vehicle.year}
                    </div>
                  </Tooltip>
                  <FlexView className="space-between margin-bottom-small">
                    <div className="black text-tiny bold">Fixed Rate</div>
                    <div className="black text-tiny">
                      {vehicle.new_fixed_price ? currencySymbol() + vehicle.new_fixed_price.toFixed(2) : '-'}
                    </div>
                  </FlexView>
                  <FlexView className="space-between margin-bottom-small">
                    <div className="black text-tiny">Before update</div>
                    <div className="black text-tiny">
                      {vehicle.old_fixed_price ? currencySymbol() + vehicle.old_fixed_price.toFixed(2) : '-'}
                      {/* {currencySymbol()}
                      {vehicle.old_fixed_price?.toFixed(2)} */}
                    </div>
                  </FlexView>
                  <Divider />
                  <FlexView className="space-between  margin-bottom-small">
                    <div className="black text-tiny bold">Per pay mile rate</div>
                    <div className="black text-tiny">{vehicle.new_per_mile_price ? CentPretty(vehicle.new_per_mile_price) : '-'}</div>
                  </FlexView>
                  <FlexView className="space-between  margin-bottom-small">
                    <div className="black text-tiny">Before update</div>
                    <div className="black text-tiny">{vehicle.old_per_mile_price ? CentPretty(vehicle.old_per_mile_price) : '-'}</div>
                  </FlexView>
                  {!(index == motorcyclesDetails.length - 1) && <Divider className="divider_between_motorcycles" />}
                </Container>
              ))}
            </Paper>
          </FlexView>
          {modifyContext.isUserNeedToSign && (
            <Grid xs={12}>
              <FlexView className="signing-notice" vAlignContent="center" hAlignContent="left" col>
                <div className="text-tiny margin-top-basic">
                  * Pay attention – the recent changes will require the customer to sign on the following{' '}
                  <a className="forms_link bold" onClick={DownloadPdfRequest}>
                    form
                  </a>
                </div>
              </FlexView>
            </Grid>
          )}
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
      <FlexView vAlignContent="center" hAlignContent="left">
        <Button
          onClick={onBackClick}
          variant="contained"
          startIcon={<KeyboardBackspaceIcon />}
          disableElevation
          className="back-button-flow margin-right-small"
        >
          Back to Modify
        </Button>
        <ContinueButton onClick={onContinue} label="Save" />
      </FlexView>

      <Dialog open={clickedSave} closeDialog={handleClose} maxWidth={'xs'}>
        <FlexView vAlignContent="center" hAlignContent="center" column>
          <div className="text-title blue bold margin-top-basic textcenter margin-bottom-basic">Hold on!</div>
          <Grid container>
            <Grid xs={12}>
              <div className="margin-left-basic-plus margin-right-basic margin-bottom-basic">
                Are you sure you wish to save the recent modifications made for the{' '}
                {modifyContext.isRenewal ? 'renewed policy?' : 'policy?'}
              </div>
            </Grid>
            <Grid>
              <FlexView className="margin-buttom-30" vAlignContent="center" hAlignContent="center" column={false}>
                <Button onClick={onSave} variant="contained" className="save_button_popup">
                  Yes
                </Button>
                <Button onClick={handleClose} variant="contained" className="cancel-button-popup">
                  Cancel
                </Button>
              </FlexView>
            </Grid>
          </Grid>
        </FlexView>
      </Dialog>

      <SkywatchDialog maxWidth={'xs'} open={openMidtermAmount} closeDialog={() => setOpenMidtermAmount(false)} shouldScroll={true}>
        <Typography variant="h6">
          Amount:{' '}
          {midtermAmountDetails.total_amount?.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </Typography>
        {midtermAmountDetails.result.map((r, idx) => (
          <div key={r.name}>
            <Typography paragraph={true}>{r.name}</Typography>
            <Typography display="block">
              Pro-rated fix price:{' '}
              {r.fixed_price.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
            <Typography display="block">Miles amount charged: {r.miles_charged}</Typography>
            <Typography display="block">
              Per mile rate:{' '}
              {r.per_mile_rate.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
            <Typography display="block">
              Final miles charge:{' '}
              {r.per_mile_price.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
            <Divider className="divider_between_motorcycles" />
          </div>
        ))}
        <Typography variant="h8">
          Minimum Earned Premium:{' '}
          {midtermAmountDetails.minimum_earned_premium?.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </Typography>
        <Grid container direction="row-reverse">
          <GreenButton className="margin-bottom-basic margin-top-basic" onClick={onSave}>
            Ok
          </GreenButton>
        </Grid>
      </SkywatchDialog>
    </>
  )
}
